const doc = [({"en":({"js":({"admin":({"competition_surveys":({"surveys":({"the_survey_was_removed_from_the_competition":"The survey was removed from the competition"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;